import {
  FailableAction,
  failableActionCreator,
  Memoed,
  PayloadAction,
  payloadActionCreator,
  Loadable,
  actionCreator,
} from '@library/react-toolkit'
import { LocationChangeAction } from 'connected-react-router'
import { pipe } from 'fp-ts/lib/function'
import { eq, option, string } from 'fp-ts'
import { Action } from 'redux'
import { Item } from '../../types'

export type PendingItem = Item & { status: boolean }
export const eqItem: eq.Eq<Item> = pipe(
  string.Eq,
  eq.contramap(i => i.name)
)

export type NewItem = Omit<Item, 'id'>

export type Query = {
  page: number
  itemsPerPage: number
  sort?: [keyof Item, 'asc' | 'desc']
  name?: string
}

export type ItemsData = { data: Item[]; count: number }

export type State = {
  createModalOpen: boolean
  editingItem?: Item
}

export type ToggleCreateItemModal = Action<'ITEMS/toggle_create_modal'>
export const toggleCreateItemModal = actionCreator<ToggleCreateItemModal>(
  'ITEMS/toggle_create_modal'
)

export type OpenEditItemModal = PayloadAction<'ITEMS/open_edit_modal', Item>
export const openEditItemModal = payloadActionCreator<OpenEditItemModal>(
  'ITEMS/open_edit_modal'
)

export type CloseEditItemModal = Action<'ITEMS/close_edit_modal'>
export const closeEditItemModal = actionCreator<CloseEditItemModal>(
  'ITEMS/close_edit_modal'
)

export type Actions =
  | ToggleCreateItemModal
  | OpenEditItemModal
  | CloseEditItemModal
  | LocationChangeAction
